import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom";
import classnames from "classnames"

import { useFirebase } from "@meddbriefer/mdb-firebase"
import {
    getScenarioTypeObject,
    getDocument,
    saveDocument,
    deleteDocument
} from "@meddbriefer/scenario-data/index.js";

import { updateSchema } from "./traumaScenario";



const deepCopy = (data) => {
    // console.log(data)
    const copied = JSON.parse(JSON.stringify(data))
    // console.log("success")
    return copied
}


// const getSystemInterventions = (scenTypeData) => {
//     let tmp = scenTypeData._interventions
//                 .filter(e => !!e.system)
//                 .map(e => {return {id: e.id, type: MDB_TYPES.INTERV, label: e.label, system: e.system}})
//     const sysIntvs = groupByKey(tmp, "system")
//     console.log(sysIntvs)
//     return sysIntvs
// }


const mergeData = (scenarioData, scenarioTypeData) => {
    const scenario = deepCopy(scenarioData)

    scenario.checkListMetaData = deepCopy(scenarioTypeData._checklist)
    scenario.medications = deepCopy(scenarioTypeData._medications)
    scenario.interventions = deepCopy(scenarioTypeData._interventions)
    // FIXME: need to perform scenario-specfic value substitutions of some prompt/answer labels
    // (label/abbrLabels will begin/end with '{' and '}')
    scenario.interventionPrompts = deepCopy(scenarioTypeData._interventionPrompts)
    scenario.interventionPromptAnswers = deepCopy(scenarioTypeData._interventionPromptAnswers)
    // scenario.systemInterventions = deepCopy(getSystemInterventions(scenarioTypeData))
    scenario.interventionMenuCategories = deepCopy(scenarioTypeData._interventionMenuCategories)
    scenario.interventionMenuItems = deepCopy(scenarioTypeData._interventionMenuItems)
    return scenario
}


export default function PublishScenario(props) {
    const {db} = useFirebase()
    const {scenarioId} = props.match.params
    const history = useHistory()
    const [versionName, setVersionName] = useState("")
    const [error, setError] = useState(null)
    const [mergedData, setMergedData] = useState(null)
    const [versions, setVersions] = useState([])

    const changeFileName = (event) => {
        setVersionName(event.target.value)
    }

    const unpublish = async (publishedScenarioID) => {
        deleteDocument(db, "published-scenarios", publishedScenarioID)
        .then(loadPublishedScenarioVersions(mergedData.name))
    }

    const publishWithNewName = async (event) => {
        event.preventDefault()
        if ("" === versionName) {
            setError("Please provide a name to publish this version of the scenario data as.")
        } else {
            setError(null)
            await publishData(versionName)
            setVersionName("")
        }
    }

    const republishAs = (versionName) => {
        const existingVersion = versions.find(ver => ver.version === versionName)
        if (window.confirm(`Are you sure you wish to replace the data currently published as "${versionName}"?`)) {
            publishData(versionName, existingVersion.id)
        }
    }

    const publishData = async (versionName, versionID = null) => {
        const doc = Object.assign({}, mergedData, { version: versionName, datePublished: new Date().toLocaleString() })
        delete doc.id
        if (versionID) {
            doc.id = versionID
        }
        await saveDocument(db, "published-scenarios", doc)
        await loadPublishedScenarioVersions(doc.name)
        alert(`scenario data published as ${versionName}`)
        history.push("/scenarios")
    }

    const loadPublishedScenarioVersions = async (scenarioName) => {
        let variants = []
        const scenVersions = await db.collection("published-scenarios")
            .where("name", "==", scenarioName)
            .where("schemaVersion", "==", "V2")
            .get()
        if (scenVersions.size > 0) {
            variants = scenVersions.docs.map(doc => {
                // data is HUGE, we only need: id, name, datePublished, and version fields
                const { id, name, datePublished, version } = doc.data()
                return { id, name, datePublished, version }
            })
        }
        setVersions(variants)
    }

    useEffect(() => {
        (async () => {
            const scenData = await getDocument(db, "scenarios", scenarioId)
            const scenTypeData = await getScenarioTypeObject(db, scenData.scenarioType, scenData.schemaVersion)
            const scen = updateSchema(scenData, scenTypeData)
            const merged = mergeData(scen, scenTypeData)
            console.log(merged)
            setMergedData(merged)
            loadPublishedScenarioVersions(scenData.name)
        })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [db, scenarioId])

    if (!mergedData) {
        return <div>Loading...</div>
    }
    return (
        <div>
            <h1>Publish Scenario: "{mergedData.name}" (type: "{mergedData.scenarioType}") </h1>
            <h4>First verify that the following pieces of information is ready for publication:</h4>
            <ul>
                <li>findings for assessment steps are specified</li>
                <li>problems and solutions are specified: <b>{(!!mergedData.problems).toString()}</b></li>
                <li>answers to intervention prompts are specified</li>
                <li>medication-related info is specified</li>
            </ul>

            <h4>Published versions of this scenario:</h4>
            <table style={{
                width: "80%"
            }}>
                <thead>
                    <tr>
                        <th>Version</th>
                        <th>Date Published</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {versions.map(item =>
                    <tr key={item.version}>
                        <td>{item.version}</td>
                        <td>{item.datePublished}</td>
                        <td>
                            <button onClick={() => republishAs(item.version)}> Republish using this name </button>
                            <button onClick={() => unpublish(item.id)}>Unpublish</button>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>

            <label> Publish using name:
                <input
                    type="text"
                    placeholder="Name for this version"
                    value={versionName}
                    onChange={changeFileName}
                />

            </label>
            <button onClick={publishWithNewName}>Publish</button>

            <div className={classnames({"hidden": !error })}>{error}</div>
        </div>
    )
}